import Gardener from 'scoreboard/components/gardener'
import Stream from 'stream'
import _ from 'lodash'
import gardenerDataJson from '../gardener-data.json'

/**
 * Sets up a tree with this structure:
 *
 * Document A (ID 1)
 * Folder (ID 2)
 *     Document B (ID 3)
 * Document C (ID 4)
 * Document D (ID 5)
 * Document E (ID 6)
 * Document E (ID 7)
 * Document E (ID 8)
 * Document E (ID 9)
 * Document E (ID 10)
 * Document E (ID 11)
 * Document E (ID 12)
 * Document E (ID 13)
 * Document E (ID 14)
 * Document E (ID 15)
 * Document E (ID 16)
 * Document E (ID 17)
 * Document E (ID 18)
 * Document E (ID 19)
 * Document E (ID 20)
 */
var TestGardener = Gardener.extend({

	_stream: function() {
		this.testStream = new Stream()
		this.testStream.pause = this.testStream.resume = _.identity
		return this.testStream
	},

	startStream: function() {
		// note fs.createReadStream doesn't work with browserify, and
		// browserify-fs requires IE10+
		_.cloneDeep(gardenerDataJson).forEach(node => this.testStream.emit('data', node))
		this.testStream.emit('end')
	},

	_treeOptions: function() {
		var treeOptions = Gardener.prototype._treeOptions.apply(this, arguments)
		treeOptions.accessors = { icon: 'icon' }
		return treeOptions
	},

	move: function(node, newParent, previousParent, newIndex, prevIndex) {
		// Fired when a node is reordered. Just log stuff since this is only a test.
		console.log(node)
		console.log(previousParent)
		console.log(newParent)
		console.log(newIndex)
		console.log(prevIndex)
	}
})

export default TestGardener
